import React from 'react'

export const Forest = () => {
  return <div>'welcome to da forest'</div>
}
